module.exports = __webpack_public_path__ + "img/googleauthenticator.4598b6b.png";